import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index' 	
import maintainManagement from './modules/maintainManagement'
import standingBookManagement from './modules/standingBookManagement'
import systemManagement from './modules/systemManagement'
import summaryManagement from './modules/summaryManagement'
import userManagement from './modules/userManagement'
// import { MenuItem } from 'ant-design-vue/types/menu/menu-item'
//    const originalPush = VueRouter.prototype.push
//    VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
//    }
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
return routerPush.call(this, location).catch(error=> error)
}
Vue.use(VueRouter)
// import user from './modules/user'

/* eslint-disable */
const routes = [
    {
        path:'/home',
        redirect:'/'
    },
    {
        path:'/login',
        name:'login',
        /* eslint-disable */
        component: () => import('@/views/auth/login.vue'),
    },
    {
        path:'/403',
        name:'403',
        component: () => import('@/views/exception/403.vue'),
    },
    {
        path:'500',
        name:'500',
        component: () => import('@/views/exception/500.vue'),
    },
    {
        path:'*',
        name:'403',
        component: () => import('@/views/exception/404.vue'),
    },
    {
        path:'/demo',
        name:'demo',
        component: () => import('@/views/demo/demo.vue'),
    },
    {
        path:'/homePage',
        name:'homePage',
        component: () => import('@/views/home/homePage.vue'),
    },
    {
        path:'/',
        name:'home',
        redirect:'/standingBookManagement/transportationAccountManagement',
        component: () => import('@/views/home'),
        children: [
            ...maintainManagement,
            ...standingBookManagement,
            ...systemManagement,
            ...summaryManagement,
            ...userManagement
        ]
     
    },

    
]
 const router = new VueRouter({
    mode:'hash',
    routes:routes
})
router.beforeEach((to,from,next)=>{
    let token = sessionStorage.getItem("Token") || localStorage.getItem("Token")
    if(token || to.path === "/login" || to.path === "/demo"){
        next()
    }else{
        next("/login")
    }
    let pathArr = to.path.split('/')
    console.log(pathArr)
    let menuList = store.state.menuList || []
    for(let i=0;i<menuList.length;i++){
      if(menuList[i].path.indexOf(pathArr[1])!==-1 ){
        // openKeys:"",
        // selectedKeys:"",
        sessionStorage.setItem('openKeys',menuList[i].id)
        //   store.state.openKeys = menuList[i].id
          let subMenusArr = menuList[i].subMenus
          for(let j=0;j<subMenusArr.length;j++){
            if(subMenusArr[j].path.indexOf(pathArr[2])!==-1){
                sessionStorage.setItem('selectedKeys',subMenusArr[j].id)
                // store.state.openKeys = subMenusArr[j].id
                
            }
        }
      }
   }
})
export default router

